<div class="products-list-container">
    <!-- Products header bar -->
    <div class="products-header-bar">
        <div class="products-header-info">
            <div class="products-title">{{ 'quotations_and_orders.products_on_order' | translate }}</div>
        </div>
        <div class="products-stats">
            <div class="products-stat">{{products.length}} {{ 'quotations_and_orders.skus' | translate }}</div>
            <div class="products-stat">{{totalQuantity()}} {{ 'quotations_and_orders.product' | translate }}</div>
            <div class="stats-divider"></div>
            <div class="products-total">{{totalPrice() | number:'1.2-2'}} {{selectedCurrency?.symbol}}</div>
        </div>
    </div>
    <app-gift-banner *ngIf="featureFlags.loyaltyEnabled && catalog && getGifts().length > 0" [gifts]="getGifts()"></app-gift-banner>
    <!-- Filter bar -->
    <div class="filter-container">
        <div class="search-filter-group">
            <div class="search-box">
                <input type="text" [formControl]="nameControleProduct" placeholder="{{ 'quotations_and_orders.search_by_product_name' | translate }}">
                <div class="search-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="#8E97A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.75 15.75L12.4875 12.4875" stroke="#8E97A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="filter-button-group">
                <button class="filter-button" (click)="setFilter()" [ngClass]="{'activeFilter': isProductsFiltered}">
                    <div class="action-button-icon filter-icon">
                        <img src="assets/icones/filter_icon.svg" alt="">
                    </div>
                    <span class="action-button-text">{{ 'common.filter' | translate }}</span>
                    <div class="clear-icon-container" *ngIf="isProductsFiltered">
                        <img class="clear-icon" (click)="clearFilter(); $event.stopPropagation()" src="assets/icones/clear-icon.svg" alt="" >
                        <div class="clear-tooltip">
                            {{ "common.clear_filters" | translate }}
                        </div>
                    </div>
                </button>
             </div>
            <button class="remove-button" [disabled]="!getSelectedProductsCount()" (click)="deleteSelectedProducts()">
                <div class="remove-icon">
                    <img src="assets/icones/delete-icon-red.svg" alt="">
                </div>
                {{ 'common.remove' | translate }} {{getSelectedProductsCount() ? '(' + getSelectedProductsCount() + ')' : ''}}
            </button>
        </div>

        <div class="currency-select-wrapper">
            <div class="currency-selector">
               <mat-select class="standard-select"
                    [disabled]="disableCurrency"
                    [formControl]="currencyControl"
                    (selectionChange)="onCurrencyChange($event.value)"
                >
                    <mat-select-trigger>
                        <span>
                            {{ selectedCurrency?.name }} ({{ selectedCurrency?.symbol }})
                        </span>
                    </mat-select-trigger>

                    <ng-container *ngFor="let currency of availableCurrencies">
                        <mat-option *ngIf="currency" [value]="currency.id">
                            {{ currency.name }} ({{ currency.symbol }})
                        </mat-option>
                    </ng-container>
                </mat-select>
            </div>

            <button class="catalog-button" (click)="goToAddProducts()">
                <div class="catalog-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                {{ (channel === 'prompt' || channel === 'email' ? 'Catalogs.new_catalog.products.listing.add_products' : 'quotations_and_orders.add_products_from_catalog') | translate }}
            </button>
        </div>
    </div>

    <!-- Products table -->
    <div class="products-table-container">
        <table class="products-table" [class.margin-on-cost-mode]="isMarginOnCost" [formGroup]="quantityForm">
            <thead>
                <tr>
                <th class="table-header header-checkbox">
                    <label class="checkbox">
                        <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                        <span class="checkmark"></span>
                    </label>
                </th>
                <th class="table-header">
                    <span class="header-label">Img</span>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('name')">
                        <span class="header-label">{{ 'quotations_and_orders.product' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'name' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'name' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                    <span class="subheader-label">SKU</span>
                </th>
                <th class="table-header">
                    <span class="header-label">{{ 'quotations_and_orders.brand' | translate }}</span>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('price_unit')">
                        <span class="header-label">{{ 'quotations_and_orders.retail_price' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header" *ngIf="isMarginOnCost">
                    <div class="header-title-with-sort" (click)="sort('cost')">
                        <span class="header-label">{{ 'Catalogs.new_catalog.products.listing.cost' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'cost' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'cost' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header" *ngIf="isMarginOnCost">
                    <div class="header-title-with-sort" (click)="sort('discount')">
                        <span class="header-label">{{ 'Catalogs.new_catalog.products.listing.margin' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'discount' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'discount' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header" *ngIf="!isMarginOnCost">
                    <div class="header-title-with-sort" (click)="sort('discount')">
                        <span class="header-label">{{ 'quotations_and_orders.discount' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'discount' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'discount' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header" *ngIf="catalogMaxExtraDiscount > 0">
                    <div class="header-title-with-sort" (click)="sort('extra_discount')">
                        <span class="header-label">{{ 'quotations_and_orders.extra_discount' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'extra_discount' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'extra_discount' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('final_price')">
                        <span class="header-label">{{ 'quotations_and_orders.unit_price' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'final_price' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'final_price' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('markup')">
                        <span class="header-label">{{ 'quotations_and_orders.margin' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'markup' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'markup' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('quantity')">
                        <span class="header-label">{{ 'quotations_and_orders.quantity' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'quantity' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'quantity' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort" (click)="sort('name')">
                        <span class="header-label">{{ 'quotations_and_orders.total_amount' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'name' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'name' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                    <span class="subheader-label">{{ 'quotations_and_orders.total_units' | translate }}</span>
                </th>
                <th class="table-header">
                    <div class="header-title-with-sort stock-header" (click)="sort('stock')">
                        <span class="header-label">{{ 'inventory.stock' | translate }}</span>
                        <div class="sort-arrows">
                            <span class="arrow-up" [class.active]="currentSortField === 'stock' && currentSortDirection === 'asc'"></span>
                            <span class="arrow-down" [class.active]="currentSortField === 'stock' && currentSortDirection === 'desc'"></span>
                        </div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let product of currentFilter; trackBy: trackByProductId">
                <!-- Product rows -->
                <tr class="product-row">
                    <td class="product-cell">
                    <label class="checkbox">
                        <input type="checkbox" [checked]="product.checked" (change)="checkProduct(product, $event)">
                        <span class="checkmark"></span>
                    </label>
                    </td>
                    <td class="product-cell" (click)="showStockFulfillment(product)" style="cursor: pointer;">
                        <div class="product-image">
                            <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="">
                        </div>
                    </td>
                    <td class="product-cell" (click)="showStockFulfillment(product)">
                        <div class="product-details">
                            <div class="product-name">{{product.name}}</div>
                            <div class="product-sku">{{product | productCode}}</div>
                        </div>
                    </td>
                    <td class="product-cell brand-cell" (click)="showStockFulfillment(product)">
                        <div class="product-brand">
                            {{product.brand_name}}
                        </div>
                    </td>
                    <td class="product-cell price-cell" (click)="showStockFulfillment(product)">
                        <ng-container *ngIf="!product.is_buy_x_get_y_line; else giftTag">
                            <div class="price-info">
                                {{
                                    getCurrencyPrice(product, 'sales_price')
                                        ? (getCurrencyPrice(product, 'sales_price')! | number:'1.2-2') + ' ' + getCurrencySymbol()
                                        : '--'
                                }}
                                <app-gift-tooltip *ngIf="featureFlags.loyaltyEnabled && getProductGifts(product).length > 0" [gifts]="getProductGifts(product)"></app-gift-tooltip>
                            </div>
                        </ng-container>
                        <ng-template #giftTag>
                            <span class="free-badge">
                                <img src="assets/icones/gift.svg" alt=""/>
                                    Gift
                            </span>
                        </ng-template>
                    </td>
                    <td class="product-cell price-cell" *ngIf="isMarginOnCost" (click)="showStockFulfillment(product)">
                        {{ product.cost ? (product.cost + ' ' + (selectedCurrency?.symbol || '')) : '--' }}
                    </td>
                    <td class="product-cell" *ngIf="isMarginOnCost">
                        <div class="discount-badge" *ngIf="product.cost && product.cost > 0">
                            <input [(ngModel)]="product.discount" type="number" class="discount-input" [ngModelOptions]="{standalone: true}" (input)="updateDiscount($event, product)">
                            <span class="discount-percent">%</span>
                        </div>
                        <span *ngIf="!product.cost || product.cost === 0">--</span>
                    </td>
                    <td class="product-cell" *ngIf="!isMarginOnCost">
                        <ng-container *ngIf="!product.is_buy_x_get_y_line; else noData">
                            <div class="discount-badge" *ngIf="product.price_unit">
                                <input [(ngModel)]="product.discount" type="number" class="discount-input" [ngModelOptions]="{standalone: true}" (input)="updateDiscount($event, product)">
                                <span class="discount-percent">%</span>
                            </div>
                        </ng-container>
                    </td>
                    <td class="product-cell price-cell" *ngIf="catalogMaxExtraDiscount > 0" (click)="showStockFulfillment(product)">
                        <!-- <div class="unit-price"
                        [ngClass]="{'invalid': quantityForm.get('extra_discount_' + product.product_id)?.touched && quantityForm.get('extra_discount_' + product.product_id)?.errors}"
                        >
                            <input class="unit-price-input" [formControlName]="'extra_discount_' + product.product_id" type="number" [value]="product.extra_discount"
                            min="0" [max]="product.max_extra_discount!"
                              (input)="updateExtraDiscount($event, product)">
                            <span class="unit-price-currency">%</span>
                        </div> -->

                        <ng-container *ngIf="!product.is_buy_x_get_y_line; else noData">
                            {{ product.extra_discount || 0 }} %
                        </ng-container>
                    </td>
                    <td class="product-cell">
                        <!-- The line says where its price came from and lets the operator
                             see the others. The "i" and the badge are SIBLINGS of the
                             input box, not contents of it: `.unit-price` is a fixed 110px
                             control, and putting them inside it pushes the badge onto a
                             second line and over the next column. -->
                        <div class="unit-price-cell" *ngIf="!product.is_buy_x_get_y_line; else noPrice">
                          <div class="unit-price"
                          [ngClass]="{'invalid': quantityForm.get('final_price_' + product.product_id)?.touched && quantityForm.get('final_price_' + product.product_id)?.errors}"
                          >
                              <!-- A `none` line has no price to type into: the order screen
                                   renders it as "No price" and so does this one, instead of
                                   the catalog number the field happens to hold. -->
                              <ng-container *ngIf="!isNoPrice(product); else unitPriceNone">
                                <input class="unit-price-input" [formControlName]="'final_price_' + product.product_id" type="number" [value]="product.final_price"
                                  (input)="updateFinalPrice($event, product)">
                                <span class="unit-price-currency">{{selectedCurrency?.symbol}}</span>
                              </ng-container>
                              <ng-template #unitPriceNone>
                                <span class="unit-price-none">{{ 'quotations_and_orders.price_source_none' | translate }}</span>
                              </ng-template>
                          </div>
                          <ui-svg-icon class="unit-price-info" tooltip=""
                              [tooltipTemplate]="addPriceDetailsTpl"
                              [offsetLeft]="200"
                              [offsetTop]="-10"
                              [maxWidth]="'480px'"
                              svgIcon="info" size="medium" (click)="$event.stopPropagation()">
                          </ui-svg-icon>
                          <span class="price-source-badge"
                                *ngIf="hasCustomer && priceTypeFor(product) as priceType"
                                [ngClass]="'badge-' + priceType">
                              {{ 'quotations_and_orders.price_source_' + priceType | translate }}
                          </span>
                        </div>

                        <ng-template #addPriceDetailsTpl>
                            <div class="price-no-customer" *ngIf="!hasCustomer; else addPriceTooltip">
                                {{ 'quotations_and_orders.price_needs_a_customer' | translate }}
                            </div>
                            <!-- THE tooltip every other surface shows (system row, AI
                                 row, no-price row, other known prices), not a panel of
                                 this page's own. "No price" is applied from here, and
                                 the order's lock reaches the buttons. -->
                            <ng-template #addPriceTooltip>
                                <app-price-details-tooltip
                                    [product]="product"
                                    [currencySymbol]="selectedCurrency?.symbol || ''"
                                    [noPriceLocked]="noPriceLocked"
                                    [candidates]="candidatesFor(product)"
                                    [policyTrace]="policyTraceFor(product)"
                                    [selectedCandidate]="selectedCandidateFor(product)"
                                    (seeAllCandidates)="openCandidatesPanelFor(product)"
                                    (applyPrice)="onApplyPriceFromCandidates(product, $event)">
                                </app-price-details-tooltip>
                            </ng-template>
                        </ng-template>
                    </td>
                    <td class="product-cell markup-cell" (click)="showStockFulfillment(product)">{{product.cost && (getCurrencyPrice(product, 'final_price') || product.final_price) ? ((((getCurrencyPrice(product, 'final_price') || product.final_price) - product.cost) / (getCurrencyPrice(product, 'final_price') || product.final_price) * 100).toFixed(2) + '%') : '--'}}</td>
                    <td class="product-cell">
                        <ng-container *ngIf="!product.is_buy_x_get_y_line; else giftQuantity">
                            <div class="quantity-badge">
                                <input
                                    type="number"
                                    class="quantity-input"
                                    [formControlName]="'quantity_' + product.product_id"
                                    [attr.min]="getSelectedHandlingUnit(product)?.quantity === 1 && product.min_qte != null ? product.min_qte : null"
                                    [attr.max]="getSelectedHandlingUnit(product)?.quantity === 1 && product.max_qte != null ? product.max_qte : null"
                                    [attr.step]="getSelectedHandlingUnit(product)?.quantity === 1 && product.increment != null ? product.increment : 1"
                                    [ngClass]="{'invalid': quantityForm.get('quantity_' + product.product_id)?.errors}">
                                    <mat-select
                                        class="hu-select"
                                        panelClass="hu-select-panel"
                                        [formControlName]="'hu_' + product.product_id"
                                        (selectionChange)="onHandlingUnitChange($event, product)"
                                        [ngClass]="{'hu-not-supported': isHandlingUnitDifferentFromDefault(product)}"
                                        *ngIf="product.handling_units && product.handling_units.length > 0"
                                        disableRipple>
                                        <mat-select-trigger>
                                        <div class="hu-option-row" *ngIf="getSelectedHandlingUnit(product)">
                                            <span class="hu-option-name">{{ getSelectedHandlingUnit(product)?.name }}</span>
                                        </div>
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let hu of product.handling_units" [value]="hu.id">
                                        <div class="hu-option-row">
                                            <span class="hu-option-name">{{ hu.name }}</span>
                                            <span class="hu-option-quantity">{{ getHandlingUnitBaseMultiplier(hu) }} units</span>
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div class="quantity-error-message" *ngIf="getQuantityErrorMessage(product)">
                                {{ getQuantityErrorMessage(product) }}
                            </div>
                        </ng-container>
                    </td>
                    <td class="product-cell total-units-cell">
                        <ng-container *ngIf="!product.is_buy_x_get_y_line; else noData">
                            <div class="product-details">
                                <div class="product-name">
                                    {{getTotalAmount(product).toFixed(2)}} {{quoteProductsData.currency?.symbol}}
                                </div>
                                <div class="subheader-label">
                                    {{getTotalUnits(product) || product.quantity}} units
                                </div>
                            </div>
                        </ng-container>
                    </td>
                    <td class="product-cell stock-cell" (click)="showStockFulfillment(product)">
                        <ng-container *ngIf="!isMultiWarehouseStock(product) && product?.is_owned === false; else owned">
                            <span class="tag">
                                {{'inventory.notOwned' | translate}}
                            </span>
                        </ng-container>
                        <ng-template #owned>
                            <div>
                                {{ stockQuantity(product) }}
                            </div>
                        </ng-template>
                    </td>
                    <ng-template #noData>
                        <span class="markup-cell">--</span>
                    </ng-template>
                    <ng-template #noPrice>
                        <span class="price-cell">0.00 {{selectedCurrency?.symbol!}}</span>
                    </ng-template>
                    <ng-template #giftQuantity>
                        <span class="price-cell">{{product.quantity}}</span>
                    </ng-template>
                </tr>
                <!-- <tr *ngIf="quantityForm.get('extra_discount_' + product.product_id)?.errors">
                    <td [attr.colspan]="catalogMaxExtraDiscount > 0 ? 11 : 10" class="alert-cell">
                        <div class="alert_div">
                            <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                            <span class="error-message" *ngIf="quantityForm.get('extra_discount_' + product.product_id)?.errors?.['required']">
                                {{ 'validation.required' | translate }}
                            </span>
                            <span class="error-message" *ngIf="quantityForm.get('extra_discount_' + product.product_id)?.errors?.['min']">
                                {{ 'validation.min' | translate: { min: quantityForm.get('extra_discount_' + product.product_id)?.errors?.['min']?.min } }}
                            </span>
                            <span class="error-message" *ngIf="quantityForm.get('extra_discount_' + product.product_id)?.errors?.['max']">
                                {{ 'validation.max' | translate: { max: quantityForm.get('extra_discount_' + product.product_id)?.errors?.['max']?.max } }}
                            </span>
                        </div>
                    </td>
                </tr> -->
                <tr *ngIf="getQuantityErrorMessage(product)" (click)="showStockFulfillment(product)">
                    <td [attr.colspan]="getTotalColumnsCount()" class="alert-cell">
                        <div class="alert_div">
                            <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                            <span class="error-message">{{ getQuantityErrorMessage(product) }}</span>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="quantityForm.get('final_price_' + product.product_id)?.touched && quantityForm.get('final_price_' + product.product_id)?.errors" (click)="showStockFulfillment(product)">
                    <td [attr.colspan]="getTotalColumnsCount()" class="alert-cell">
                        <div class="alert_div">
                            <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                            <span class="error-message">
                                {{"common.required_field" | translate }}
                            </span>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!isMultiWarehouseStock(product) && isStockAlert(product)" (click)="showStockFulfillment(product)">
                    <td [attr.colspan]="getTotalColumnsCount()" class="alert-cell">
                        <div [class]="alertType(product)" class="alert_div">
                            <div class="alert_div_content" [tooltip]="'.killing_stock_details'" [offsetLeft]="30" [offsetTop]="66">
                                <img *ngIf="alertType(product) === 'alert_div_danger'" src="assets/icones/alert_icon.svg" alt="alert-icon">
                                <img *ngIf="alertType(product) === 'alert_div_warning'" src="assets/icones/warning_icon.svg" alt="alert-icon">
                                <span class="error-message">{{alertMessage(product) + '.label' | translate}}</span>
                                <div class="tooltip-content">
                                    <div class="killing_stock_details">
                                        {{ alertMessage(product) + '.details' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="isMultiWarehouseStock(product) && hasErrorStock(product)" (click)="showStockFulfillment(product)">
                    <td [attr.colspan]="getTotalColumnsCount()" class="alert-cell" style="white-space: pre-wrap;">
                        <div *ngIf="outOfStock(product)" class="alert_div alert_div_danger" style="white-space: pre-wrap;">
                            <app-svg-icon svgIcon="inventory"></app-svg-icon>
                            <div>{{"quotations_and_orders.warehouse_stock.quantity_exceeded_global_stock" | translate}} <a>{{"quotations_and_orders.warehouse_stock.fix_issue" | translate}} →</a></div>
                        </div>
                        <div *ngIf="!outOfStock(product) && outOfStockMainWarehouse(product)" class="alert_div alert_div_warning" style="white-space: pre-wrap;">
                            <app-svg-icon svgIcon="inventory"></app-svg-icon>
                            <div>{{"quotations_and_orders.warehouse_stock.quantity_exceeded_default_warehouse" | translate}} <a>{{"quotations_and_orders.warehouse_stock.confirm_split" | translate}} →</a></div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <div *ngIf="isDetailsVisible">
    <app-catalog-product-details
        [product]="selectedProduct"
        [quoteProductsData]="quoteProductsData"
        (quantityChanged)="updateListQuantity($event)"
        (closed)="closeDetails()"
    ></app-catalog-product-details>
</div>
</div>
<app-stock-fulfillment
    [visible]="isStockFulfillmentVisible"
    [product]="selectedStockFulfillmentProduct"
    [order]="order"
    (reservationChanged)="updateReservation($event)"
    (closed)="closeStockFulfillment()"
></app-stock-fulfillment>

<!-- Every price known for one line, expired ones included. Reached from the
     tooltip's truncation link and from nowhere else (same rule as the order
     screen). -->
<div class="price-candidates-drawer-backdrop"
     *ngIf="candidatesPanelProduct"
     (click)="closeCandidatesPanel()">
  <app-price-candidates-panel
    [candidates]="candidatesFor(candidatesPanelProduct)"
    [policyTrace]="policyTraceFor(candidatesPanelProduct)"
    [selectedCandidate]="selectedCandidateFor(candidatesPanelProduct)"
    [currencySymbol]="selectedCurrency?.symbol || ''"
    [noPriceLocked]="noPriceLocked"
    [currentPriceType]="priceTypeFor(candidatesPanelProduct)"
    [currentPrice]="isNoPrice(candidatesPanelProduct) ? null : candidatesPanelProduct.final_price"
    (applyPrice)="onApplyPriceFromCandidates(candidatesPanelProduct, $event); closeCandidatesPanel()"
    (closePanel)="closeCandidatesPanel()">
  </app-price-candidates-panel>
</div>